/**
 * @Desc:   工具函数
 * @Date:   2019-07-03
 * @Author: Bob
 */

import config from '@/service/config'
import { version } from '@/authLib/config'
import store from '@/store'
const Jockey = require('@/vendor/jockey').default
const imp = {}

// 获取url 中的关键字
imp.getQueryString = function getQueryString (key) {
  return imp.getUrlQuery()[key]
}

// 获取url 中的关键字
imp.getUrlQuery = function getUrlQuery (decode = false) {
  const query = {}
  const queryStr = location.search.slice(1)
  const queryArr = queryStr.split('&')
  for (const item of queryArr) {
    const itemArr = item.split('=')
    if (itemArr.length === 2) {
      query[itemArr[0]] = decode ? decodeURIComponent(itemArr[1]) : itemArr[1]
    }
  }
  return query
}

/**
 * 设置html标题 (多语言配置文件标题默认为title)
 * @api public
 */
imp.setHtmlTitle = title => {
  document.title = title
  Jockey.send('setNaviTitle', {
    title
  })
}

/**
 * 设置多个标题 (setMultiTitle中的title不会影响到setNaviTitle中的title)
 * @api public
 */
imp.setMultiTitle = params => {
  document.title = ''
  const item = {
    title: params.title, // 标题
    subTitle: params.subTitle // 小标题
  }
  if (params.titleColor) {
    item.titleColor = params.titleColor // 标题颜色(默认#333333)
  }
  if (params.subTitleColor) {
    item.subTitleColor = params.subTitleColor // 小标题颜色(默认#666666)
  }
  Jockey.send('setMultiTitle', {
    ...item
  })
}

/**
 * 语言枚举类型
 * @param {String} lang
 * @api public
 */
imp.getLang = (lang) => {
  const langEnum = {
    'zh-CN': 'zhCN',
    'zh-HK': 'zhHK',
    'en-US': 'enUS'
  }
  return langEnum[lang] || 'zhHK'
}

/**
 * 切换多语言
 * @param {Object} i18n 多语言实例对象
 * @param {String} lang 待切换的目标语言，如en-US
 * @api public
 */
imp.changeLang = (i18n, lang) => {
  // 语言
  const locale = imp.getLang(lang)
  // 切换非标题语言
  i18n.locale = locale
  // 切换标题语言
  imp.setHtmlTitle(i18n.t('title'))
}

/**
 * 格式化日期
 * @param {Date} t 日期
 * @param {String} str 格式化字符串
 * @return {String}
 * */
imp.formatDate = (t, str) => {
  if (str === void 0) {
    // eslint-disable-next-line
    str = 'yyyy-MM-dd'
  }
  var obj = {
    yyyy: t.getFullYear(),
    // eslint-disable-next-line
    yy: ("" + t.getFullYear()).slice(-2),
    M: t.getMonth() + 1,
    MM: (`0${t.getMonth() + 1}`).slice(-2),
    d: t.getDate(),
    dd: (`0${t.getDate()}`).slice(-2),
    H: t.getHours(),
    HH: (`0${t.getHours()}`).slice(-2),
    h: t.getHours() % 12,
    hh: (`0${t.getHours() % 12}`).slice(-2),
    m: t.getMinutes(),
    mm: (`0${t.getMinutes()}`).slice(-2),
    s: t.getSeconds(),
    ss: (`0${t.getSeconds()}`).slice(-2),
    w: ['日',
      '一',
      '二',
      '三',
      '四',
      '五',
      '六'][t.getDay()]
  }
  return str.replace(/([a-z]+)/ig, ($1) => { return obj[$1] })
}

// 使用iframe 的通信
imp.wathcIframeEvent = (callBack, eventName, envconfig) => {
  const eventFun = (event) => {
    let eventOrigin = envconfig.domain[envconfig.env]
    if (envconfig.env === 'LOCAL') {
      eventOrigin = envconfig.domain.LOCALFTS
    }
    if (event && event.data && event.data.eventName === eventName && event.origin === eventOrigin) {
      if (event.data && Object.keys(event.data).length > 0) {
        callBack(event.data)
        window.removeEventListener('message', eventFun) // ?? 不应该移除事件监听吧
      }
    }
  }
  window.addEventListener('message', eventFun, false)
}

/**
 * 订阅消息
 * @param {String} eventName 事件名称
 * @param {Object} config 域名配置
 * @param {Function} cb 回调函数
 * @api public
 */
imp.ion = (eventName, config, cb) => {
  window.addEventListener('message', event => {
    const env = config.env === 'LOCAL' ? 'LOCALFTS' : config.env
    if (event.origin !== config.domain[env] || event.data.eventName !== eventName) {
      return
    }
    const data = event.data.data
    cb(data)
  })
}

/**
 * 发布消息
 * @param {Object} otherWindow 目标窗口引用
 * @param {String} eventName 事件名称
 * @param {Object} data 消息实体
 * @param {Object} config 域名配置文件
 * @api public
 */
imp.iemit = (otherWindow, eventName, data, config) => {
  const env = config.env === 'LOCAL' ? 'LOCALFTS' : config.env
  const targetOrigin = config.domain[env]
  otherWindow.postMessage({
    eventName,
    data
  }, targetOrigin)
}

/**
 * 设置本地缓存
 * @param {String} key 键
 * @param {Object} value 值
 * @param {Number} expireTime 过期时间（秒）
 * @api public
 */
imp.saveLocal = (key, value, expireTime) => {
  const data = {
    expireTime: new Date().getTime() + Number(expireTime) * 1000,
    value
  }
  localStorage.setItem(`mma-h5-fnx-v1-${key}`, JSON.stringify(data))
}

/**
 * 获取本地缓存
 * @param {String} key 键
 * @returns {Object} 值
 * @api public
 */
imp.getLocal = key => {
  const now = new Date().getTime()
  const data = JSON.parse(localStorage.getItem(`mma-h5-fnx-v1-${key}`))
  if (!data) {
    return ''
  }
  if (data.expireTime < now) { // 过期
    localStorage.removeItem(`mma-h5-fnx-v1-${key}`)
    return ''
  }
  return data.value
}

imp.getQueryStringKey = function getQueryStringKey (key) {
  var reg = new RegExp(`(^|/?)${key}=([^&]*)(&|$)`, 'i')
  var r = window.location.href.substr(1).match(reg)
  if (r != null) return unescape(r[2]); return null
}

/**
 * @function multiplyOrdivide
 * @param { Number } m 被乘数/被除数
 * @param { Number } n 乘数/除数
 * @param { Boolean } multiply true是乘法, false是除法
 * @returns { Number } 运算结果
 * @description 浮点数乘除运算
 */
imp.multiplyOrdivide = (m, n, multiply = true) => {
  if (Number(m).toString() === 'NaN' || Number(n).toString() === 'NaN') {
    return ''
  }
  const mTimes = imp.isFloatNumber(m) ? `${m}`.split('.')[1].length : 0
  const nTimes = imp.isFloatNumber(n) ? `${n}`.split('.')[1].length : 0
  const timesAll = Math.pow(10, mTimes + nTimes)
  const timesDiff = Math.pow(10, nTimes - mTimes)
  const intM = parseFloat(m) * Math.pow(10, mTimes)
  const intN = parseFloat(n) * Math.pow(10, nTimes)
  const result = multiply ? (intM * intN) / timesAll : intM / intN * timesDiff
  return result
}

// 数据千分位处理
/**
 * isNumber
 * 合理的数字，数字字符串
 * */
imp.isNumber = (n) => {
  var reg = /^-?[0-9]+\.?[0-9]*$/
  return reg.test(n)
}

// 是否浮点数
imp.isFloatNumber = (n) => {
  var reg = /^-?[0-9]+\.[0-9]+$/
  return reg.test(n)
}

/**
 * @数字千分符
 * @param {Number} num: 将被处理的值
 * @param {Boolean} isToFixed: 标记是否进行保留小数位处理(默认true)
 * @param {Number} limitNum: 保留的小数位(默认2位小数)
 * **/
imp.toThousands = (num, isToFixed = true, limitNum = 2) => {
  let flag = true
  let n = Number(num)
  // 非数字，返回本身
  if (n.toString() === 'NaN') {
    return num
  }

  if (n < 0) {
    flag = false
    n = Math.abs(n)
  }

  if (isToFixed) {
    n = imp.toFixed(n, limitNum)
  }

  const re = /\d{1,3}(?=(\d{3})+$)/g
  n = (n || 0)
    .toString()
    .replace(/^(\d+)((\.\d+)?)$/, (s, s1, s2) => { return s1.replace(re, '$&,') + s2 })
  return flag ? n : `-${n}`
}

/**
 * 保留两位小数（修复toFixed精度问题）
 * @param {Number} num 待处理数
 * @param {Number} decimal 保留小数位
 * @param {type} type 保留小数类型，floor向下，ceil 向上, round四舍五入, intercept截取； 默认为round
 * @returns {String} 返回保留小数后的字符串
 */
imp.toFixed = (num, decimal, type = 'round') => {
  // 非数值类型
  if (typeof num !== 'number' || typeof decimal !== 'number') {
    return num
  }

  // 保留小数位(0 至 100)
  if (decimal < 0 || decimal > 100) {
    return ''
  }

  // 待处理数取正值
  const value = num < 0 ? -num : num
  // 小数位取整
  const s = Math.floor(decimal)
  // 倍数
  const times = Math.pow(10, s)
  // 临时值
  let tempValue = 0

  // 向上保留小数
  if (type === 'ceil') {
    tempValue = Math.ceil((value * times).toFixed(2)) / times
  }

  // 向下保留小数
  if (type === 'floor') {
    tempValue = Math.floor((value * times).toFixed(2)) / times
  }

  // 四舍五入保留小数
  if (type === 'round') {
    tempValue = (value * (times * 10) + 5) / 10
    tempValue = parseInt(tempValue, 10) / times
  }

  // 截取指定位小数
  if (type === 'intercept') {
    if ((/\./g).test(value)) {
      const reg = new RegExp(`[\\d,]*\\.{0,1}\\d{0,${s}}`, 'g')
      tempValue = Number(`${value}`.match(reg)[0])
    } else {
      tempValue = parseInt(value, 10)
    }
  }

  // 待处理数负数，需要加负号
  if (num < 0) {
    return `-${tempValue.toFixed(s)}`
  }

  return tempValue.toFixed(s)
}

/**
 * @fun  阻止滚动击穿
 * @params e: 事件对象 event
 * @param firstY: touchStart事件触发时的 e.targetTouches[0].clientY , 记录着首次触屏的位置
 * @param clientY: touchMove事件 e.targetTouches[0].clientY ， 记录着move事件结束时的触屏位置
 * @param dom: 滑动的dom节点
 * */
imp.preventTouchScroll = (e, firstY, clientY, dom) => {
  if (clientY > firstY && dom.scrollTop === 0) { // 下滑
    e.cancelable && e.preventDefault()
  } else if (clientY < firstY && dom.scrollHeight <= dom.scrollTop + dom.offsetHeight) { // 上滑
    e.cancelable && e.preventDefault()
  }
}

// 深复制
imp.deepCopy = function deepCopy (ret) {
  const obj = Array.isArray(ret) ? [] : {}
  for (const key in ret) {
    if (ret.hasOwnProperty(key)) {
      if (ret[key] && typeof ret[key] === 'object') {
        obj[key] = imp.deepCopy(ret[key])
      } else {
        obj[key] = ret[key]
      }
    }
  }
  return obj
}

// 千分位展示
imp.addCommas = function addCommas (nStr) {
  if (nStr === null || nStr === undefined) return ''
  nStr += '' // eslint-disable-line
  const x = nStr.split('.')
  let x1 = x[0]
  const x2 = x.length > 1 ? `.${x[1]}` : ''
  const rgx = /(\d+)(\d{3})/
  while (rgx.test(x1)) {
    x1 = x1.replace(rgx, '$1' + ',' + '$2')
  }
  return x1 + x2
}

// 去除千分位
imp.delCommas = function delCommas (nStr) {
  if (!nStr || typeof nStr !== 'string') {
    return nStr
  }
  const str = nStr.replace(/,/ig, '')
  return str - 0
}

// 添加千分位
imp.addThousands = function addThousands (val) {
  const filterData = String(val).match(/[\d|,]*\.{0,1}\d{0,2}/g)[0]
  const reg = /(\d{1,3})(?=(\d{3})+(\.(?=\d*)\d*)?$)/g
  const result = filterData.replace(reg, (match, p1) => `${p1},`)
  return result
}

// 去除千分位
imp.removeThousands = function removeThousands (val) {
  let myVal = val
  myVal = String(myVal)
    .split(',')
    .join('')
  return myVal
}

imp.toNum = function toNum (val) {
  return Number(imp.removeThousands(val))
}

/**
 * 遍历数据对象，空转换成N/A。（空包括，null, undefined, ""）
 * @param {Object} data 数据对象
 * @returns {Object}
 */
imp.emptyToNA = (data, dash) => {
  if (!data) {
    return {}
  }
  if (typeof data !== 'object') {
    return data
  }
  for (const key in data) {
    if (!data.hasOwnProperty(key)) {
      continue
    }
    if (data[key] && typeof data[key] === 'object') {
      data[key] = imp.emptyToNA(data[key], dash)
    } else if (data[key] === '' || data[key] === null || data[key] === void 0) {
      if (dash) {
        data[key] = '--'
      } else {
        data[key] = 'N/A'
      }
    }
  }
  return data
}

/**
 * 是否滑动条滚动到底部
 * @param {Object} ref dom元素
 * @return {Boolean}
 */
imp.isScrollBottom = ref => {
  const { scrollHeight, offsetHeight, scrollTop, clientHeight } = ref
  if (!scrollHeight || !offsetHeight || !clientHeight) {
    return false
  }
  // 兼容部分android机型，底部滚动条到底少2个像素
  // eslint-disable-next-line
  if (offsetHeight + scrollTop >= scrollHeight - 2 || clientHeight + scrollTop >= scrollHeight - 2) {
    return true
  } else {
    return false
  }
}

/**
 * 处理日志私密信息
 * @param {Object} data json对象
 */
imp.dealLog = data => {
  const logData = imp.deepCopy(data)
  if (Object.prototype.toString.call(logData) !== '[object Object]') return
  [...Object.getOwnPropertyNames(logData)].forEach(key => {
    const item = String(logData[key])
    if (['session', 'rndkey', 'uin', 'clientid'].indexOf(key) !== -1 && item.length) {
      const len = Math.floor(item.length / 2)
      logData[key] = item.substring(0, len) + new Array(item.length - len).fill('*')
        .join('')
    }
  })
  return logData
}

/**
 * 判断IOS
 */
imp.isIOS = () => {
  let i = 0
  let iOS = false
  const iDevice = ['iPad', 'iPhone', 'iPod']

  for (; i < iDevice.length; i++) {
    if (navigator.platform.indexOf(iDevice[i]) >= 0) {
      iOS = true
      break
    }
  }
  return iOS
}

/**
 * 判断Mac电脑
 */
imp.isMac = () => {
  return /macintosh|mac os x/i.test(navigator.userAgent)
}

/**
 * 判断apple系统
 */
imp.isApple = () => {
  return imp.isIOS() || imp.isMac()
}

/**
 * 获取跳转链接
 */
imp.getUrl = (id, params = {}, encode = false, hasRouter = false) => {
  let url = `${config.domain}`
  if (config.env === 'WebUAT' || config.env === 'WebLive') {
    url = `${config.webDomain}`
  } else if (config.env !== 'LOCAL') {
    url += `/static/cnt/ui/h5/${version}`
  }

  if (id.includes('.html')) {
    url += `/${id}`
  } else {
    url += `/${id}.html`
  }
  const keys = Object.keys(params)
  keys.forEach((key, i) => {
    if (i === 0) {
      url = hasRouter
        ? `${url}#/?${key}=${encode ? encodeURIComponent(params[key]) : params[key]}`
        : `${url}?${key}=${encode ? encodeURIComponent(params[key]) : params[key]}`
    } else {
      url += `&${key}=${encode ? encodeURIComponent(params[key]) : params[key]}`
    }
  })
  // console.log(url)
  return url
}

/**
 * 获取输入框光标位置
 */

imp.getCursorPosition = function getCursorPosition (ref) {
  if (!ref) return
  let pos
  if ('selectionStart' in ref) {
    pos = ref.selectionStart
  } else if ('selection' in document) {
    ref.focus()
    var Sel = document.selection.createRange()
    var SelLength = document.selection.createRange().text.length
    Sel.moveStart('character', -ref.value.length)
    pos = Sel.text.length - SelLength
  }
  return pos
}

/**
 * 设置输入框光标
 */
imp.setCaretPosition = function setCaretPosition (ref, pos) {
  if (!ref) return
  if (ref.setSelectionRange) {
    ref.focus()
    ref.setSelectionRange(pos, pos)
  } else if (ref.createTextRange) {
    const range = ref.createTextRange()
    range.collapse(true)
    range.moveEnd('character', pos)
    range.moveStart('character', pos)
    range.select()
  }
}

// todo: 优化
imp.getLast3Month = function getLast3Month () {
  var now = new Date()
  var year = now.getFullYear()
  var month = now.getMonth() + 1// 0-11表示1-12月
  var day = now.getDate()
  var dateObj = {}
  if (parseInt(month) < 10) {
    month = `0${month}`
  }
  if (parseInt(day) < 10) {
    day = `0${day}`
  }

  dateObj.now = `${month}/${day}/${year}`

  if (parseInt(month) === 1) { // 如果是1月份，则取上一年的10月份
    dateObj.last = `10/${day}/${parseInt(year) - 1}`
    return dateObj
  }
  if (parseInt(month) === 2) { // 如果是2月份，则取上一年的11月份
    dateObj.last = `11/${day}/${parseInt(year) - 1}`
    return dateObj
  }
  if (parseInt(month) === 3) { // 如果是3月份，则取上一年的12月份
    dateObj.last = `12/${day}/${parseInt(year) - 1}`
    return dateObj
  }

  var preSize = new Date(year, parseInt(month) - 3, 0).getDate()// 开始时间所在月的总天数
  if (preSize < parseInt(day)) {
    // 开始时间所在月的总天数<本月总天数，比如当前是5月30日，在2月中没有30，则取下个月的第一天(3月1日)为开始时间
    // eslint-disable-next-line
    const resultMonth = parseInt(month) - 2 < 10 ? (`0${parseInt(month)}` - 2) : (parseInt(month) - 2)
    dateObj.last = `/${resultMonth}/01/${year}`
    return dateObj
  }

  if (parseInt(month) <= 10) {
    dateObj.last = `0${parseInt(month) - 3}/${day}/${year}`
    return dateObj
  } else {
    dateObj.last = `${parseInt(month) - 3}/${day}/${year}`
    return dateObj
  }
}

imp.setStore = function setStore (data) {
  store.session = data.session
  store.uin = data.uin
  store.mmaclientid = data.clientid
  store.rndkey = data.rndkey
  store.prdlocation = data.prdlocation
  store.clientType = data.clientType
  if (String(store.prdlocation) === '0') {
    store.region = 'HK'
  } else if (String(store.prdlocation) === '1') {
    store.region = 'MO'
  }
}

// 节流函数
imp.throttle = function throttle (f, duration) {
  var lastTime = 0
  return function inner (...args) {
    var now = Date.now()
    if (now - lastTime > duration) {
      f.call(this, ...args)
      lastTime = now
    }
  }
}

imp.isWebLogin = function isWebLogin () {
  if (localStorage.getItem('cntloginData')) {
    var payload = JSON.parse(localStorage.getItem('cntloginData'))
    if (payload.isweblogin === true) {
      return true
    }
  }
  return false
}

imp.getPropValByLang = function getPropValByLang (lang, enVal, hkVal, cnVal) {
  switch (lang) {
    case 'en-US':
      return enVal
    case 'zh-HK':
      return hkVal
    case 'zh-CN':
      return cnVal
    default:
      return ''
  }
}

imp.getCookie = function getCookie (name) {
  const value = `; ${document.cookie}`
  const parts = value.split(`; ${name}=`)
  if (parts.length === 2) {
    return parts.pop().split(';')
      .shift()
  } else return ''
}

imp.deleteCookie = function deleteCookie (nameArr) {
  for (var i in nameArr) {
    var name = nameArr[i]
    var val = imp.getCookie(name)
    // console.log(`value of ${name}`, val)
    if (val !== '' && val !== undefined) {
      document.cookie = `${name}=; Path=/; Domain=.yflife.app; Expires=Thu, 01 Jan 1970 00:00:01 GMT;`
    }
  }
}

export default imp
